var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.isShow ? _c('portal', {
    attrs: {
      "to": "lm-modal"
    }
  }, [_c('div', {
    ref: "AddChildStorageBoxPopup",
    staticClass: "AddChildStorageBoxPopup"
  }, [_c('div', {
    staticClass: "Popup__background"
  }), _c('div', {
    staticClass: "Location__edit-location-popup Popup__container Popup__size-sm"
  }, [_c('div', {
    staticClass: "Popup__top"
  }, [_vm.isEditMode ? _c('h5', {
    staticClass: "Popup__title"
  }, [_vm._v(_vm._s(_vm.originName) + " " + _vm._s(_vm.tt('편집')))]) : _vm.isAddLocation ? _c('h5', {
    staticClass: "Popup__title"
  }, [_vm._v(" " + _vm._s(_vm.tt('위치 추가')) + " ")]) : _c('h5', {
    staticClass: "Popup__title"
  }, [_vm._v(" " + _vm._s(_vm.tt('하위 보관함 추가')) + " ")]), _c('button', {
    staticClass: "Popup__close-btn",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.hide.apply(null, arguments);
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/svg/popup-close.svg"),
      "alt": "close"
    }
  })])]), _c('div', {
    staticClass: "Popup__content"
  }, [_c('div', {
    staticClass: "Popup__input-field"
  }, [_vm.isAddLocation || _vm.isEditLocation ? _c('p', [_vm._v(_vm._s(_vm.tt('위치명'))), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]) : _c('p', [_vm._v(_vm._s(_vm.tt('하위 보관함명'))), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.name,
      expression: "name"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.tt('위치명을 입력해주세요')
    },
    domProps: {
      "value": _vm.name
    },
    on: {
      "keypress": function keypress($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.complete.apply(null, arguments);
      },
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value;
      }
    }
  })])]), _c('div', {
    staticClass: "Popup__bottom"
  }, [_c('div', {
    staticClass: "Popup__complete-btn-group Popup__btn-group"
  }, [_c('button', {
    staticClass: "Btn__close",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.hide.apply(null, arguments);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.tt('취소')) + " ")]), _c('button', {
    staticClass: "Btn__complete",
    attrs: {
      "disabled": _vm.name && !_vm.selectedInfo.name
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.complete.apply(null, arguments);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.tt('완료')) + " ")])])])])])]) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }